import * as ngCommon from '@angular/common'
import { Component } from '@angular/core'

import * as tabs from '../tabs'

@Component({
  imports: [ngCommon.NgTemplateOutlet],
  selector: 'atn-ds-floating-horizontal-tabs',
  styleUrls: ['./floating-horizontal-tabs.component.scss'],
  templateUrl: './floating-horizontal-tabs.component.html',
})
export class AtnDsFloatingHorizontalTabsComponent extends tabs.Component {}
